import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTenantScope } from '../hooks/useTenantScope';
import SelectTenantNotice from '../components/SelectTenantNotice';

// Wraps every route: in their own tenant, Globaladmin and reseller only reach the admin pages (tenantScope.ts);
// any other page shows "Select a tenant" in place of the page, at the same URL.
const TenantScopeGuard = () => {
  const { pathname } = useLocation();
  const { role, isRouteAllowed } = useTenantScope();

  return isRouteAllowed(pathname) ? <Outlet /> : <SelectTenantNotice role={role} />;
};

export default TenantScopeGuard;
